import axios from "axios";
const BASE_URL =
    process.env.REACT_APP_API_URL;

// ==============================
// GET CLIENT MANAGEMENT USERS
// ==============================

export const getClientManagementUsers =
    async (token) => {

        try {

            const response = await axios.get(
                `${BASE_URL}/subscription/api/admin/enquiries/getall`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":
                            "application/json",
                    },
                }
            );

            return response.data;

        } catch (error) {

            console.error(
                "GET Client Management Error:",
                error
            );

            throw error;
        }
    };


export const getVendorDetails =
    async (vendorId, token) => {

        try {



            const response =
                await axios.get(
                    `${BASE_URL}/food/api/vendors/${vendorId}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Vendor Details Error:",
                error
            );

            throw error;
        }
    };


export const updateVendorDetails =
    async (
        vendorId,
        formData,
        token
    ) => {

        try {

            const response =
                await axios.put(
                    `${BASE_URL}/food/api/vendors/edit/${vendorId}`,
                    formData,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "UPDATE Vendor Error:",
                error
            );

            throw error;
        }
    };

export const verifyVendorStatus =
    async (
        vendorId,
        vendorData,
        token
    ) => {

        try {



            const formData =
                new FormData();

            formData.append(
                "vendorData",

                new Blob(
                    [
                        JSON.stringify(
                            vendorData
                        ),
                    ],

                    {
                        type:
                            "application/json",
                    }
                )
            );

            const response =
                await axios.put(
                    `${BASE_URL}/food/api/vendors/edit/${vendorId}`,
                    formData,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "VERIFY Vendor Error:",
                error
            );

            throw error;
        }
    };

export const getAllEnquiries =
    async (token) => {

        try {

            const response =
                await axios.get(
                    `${BASE_URL}/subscription/api/admin/enquiries/getall`,
                    {
                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "GET Enquiries Error:",
                error
            );

            throw error;
        }
    };

export const approveVendor =
    async (
        vendorId,
        body,
        token
    ) => {

        try {

            const FOOD_BASE_URL =
                BASE_URL.replace(
                    "/subscription/api",
                    ""
                );

            const response =
                await axios.put(
                    `${FOOD_BASE_URL}/food/api/vendors/admin/vendor-registration/approval/${vendorId}`,
                    body,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "APPROVE Vendor Error:",
                error
            );

            throw error;
        }
    };

export const getSubscriptions = async (token) => {
    try {
        const response = await axios.get(
            `${BASE_URL}/subscription/api/subscription/admin/subscriptions?businessVertical=FOOD_AND_BEVERAGES`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    Accept: "*/*",
                },
            }
        );

        return response.data;

    } catch (error) {
        console.error("GET Subscriptions Error:", error);
        throw error;
    }
};


export const getPartnerDetails = async (partnerId, token) => {
    try {

        const FOOD_BASE_URL = BASE_URL.replace("/subscription/api", "");

        const response = await axios.get(
            `${FOOD_BASE_URL}/delivery/api/get/${partnerId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("GET Partner Details Error:", error);
        throw error;
    }
};

export const updatePartnerDetails = async (partnerId, formData, token) => {
    try {

        const FOOD_BASE_URL = BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${BASE_URL}/delivery/api/registration/update/${partnerId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("UPDATE Partner Error:", error);
        throw error;
    }
};


export const getAllPartners = async (token) => {
    try {

        const FOOD_BASE_URL = BASE_URL.replace("/subscription/api", "");

        const response = await axios.get(
            `${FOOD_BASE_URL}/delivery/api/admin/get/all`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {
        console.error("GET All Partners Error:", error);
        throw error;
    }
};
export const getAllDeliveryPartners = async (token) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.get(
            `${FOOD_BASE_URL}/delivery/api/admin/get/all`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("GET Delivery Partners Error:", error);

        throw error;
    }
};

export const verifyPartnerField = async (
    partnerId,
    formData,
    token
) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${FOOD_BASE_URL}/delivery/api/registration/update/${partnerId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("VERIFY Partner Error:", error);

        throw error;
    }
};
export const rejectPartnerField = async (
    partnerId,
    formData,
    token
) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${FOOD_BASE_URL}/delivery/api/registration/update/${partnerId}`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("REJECT Partner Error:", error);

        throw error;
    }
};

export const approvePartner = async (
    partnerId,
    payload,
    token
) => {
    try {



        const response = await axios.put(
            `${BASE_URL}/delivery/api/admin/approval/${partnerId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("APPROVE Partner Error:", error);

        throw error;
    }
};

export const rejectPartnerApproval = async (
    partnerId,
    requestBody,
    token
) => {
    try {

        const FOOD_BASE_URL =
            BASE_URL.replace("/subscription/api", "");

        const response = await axios.put(
            `${FOOD_BASE_URL}/delivery/api/admin/approval/${partnerId}`,
            requestBody,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

        return response.data;

    } catch (error) {

        console.error("REJECT Partner Approval Error:", error);

        throw error;
    }
};
export const fetchAllOffers = async () => {
    const token = localStorage.getItem("authToken");

    if (!token) {
        throw new Error("No auth token found");
    }

    const response = await fetch(
        `${BASE_URL}/delivery/api/admin/get/all/offers`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
};


// ================= GET ENGINEERING SUBSCRIPTIONS =================
export const getEngineeringSubscriptionsAPI =
    async () => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Authentication token not found"
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/subscription/api/subscription/admin/subscriptions?businessVertical=ENGINEERING_SERVICE`,
                    {
                        method: "GET",

                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",

                            Accept:
                                "*/*",
                        },
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP ${response.status}`
                );
            }

            const subscriptions =
                await response.json();

            // Mapping response
            const mapped =
                (
                    Array.isArray(
                        subscriptions
                    )
                        ? subscriptions
                        : []
                ).map(
                    (s, idx) => ({
                        id:
                            s.subscriptionId ??
                            idx,

                        vendorName:
                            s.customerName ||
                            "—",

                        vendorId:
                            s.vendorId ||
                            "—",

                        email:
                            s.email ||
                            s.customerEmail ||
                            "—",

                        mobileNumber:
                            s.customerMobile ||
                            "—",

                        city:
                            s.city ||
                            "—",

                        businessVertical:
                            s.businessVertical ||
                            "—",

                        startDate:
                            s.startDate,

                        endDate:
                            s.endDate,

                        billingCycle:
                            s.billingCycle ||
                            "—",

                        totalAmount:
                            s.totalAmount ||
                            0,

                        status:
                            s.status ||
                            "—",

                        selectedModules:
                            s.selectedModules ||
                            [],

                        remainingDays:
                            s.remainingDays ||
                            0,

                        message:
                            s.message ||
                            "",
                    })
                );

            return mapped;

        } catch (error) {

            console.error(
                "❌ Error fetching engineering subscriptions:",
                error
            );

            throw error;
        }
    };


// ================= GET ENGINEERING ENQUIRIES =================
export const getEngineeringEnquiriesAPI =
    async (signal) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Authentication token not found"
                );
            }

            const response =
                await fetch(
                    `${BASE_URL}/subscription/api/admin/enquiries/getall`,
                    {
                        method: "GET",

                        signal,

                        headers: {
                            Authorization:
                                `Bearer ${token}`,

                            "Content-Type":
                                "application/json",
                        },
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status}`
                );
            }

            const fetchedData =
                await response.json();

            // Filter ENGINEERING_SERVICE
            const filteredData =
                fetchedData.filter(
                    (item) => {

                        return (
                            Array.isArray(
                                item.businessVerticals
                            ) &&
                            item
                                .businessVerticals
                                .length === 1 &&
                            item
                                .businessVerticals[0] ===
                            "ENGINEERING_SERVICE"
                        );
                    }
                );

            // Add extra fields
            const dataWithExtras =
                filteredData.map(
                    (item, index) => ({
                        ...item,

                        sno: index + 1,

                        category:
                            item.category ||
                            "N/A",

                        subscription:
                            item.subscription ||
                            "N/A",

                        isInterestedInSales:
                            null,
                    })
                );

            return dataWithExtras;

        } catch (error) {

            console.error(
                "❌ Error fetching engineering enquiries:",
                error
            );

            throw error;
        }
    };


// ================= GET ENGINEERING VENDOR DETAILS =================
export const getEngineeringVendorDetailsAPI =
    async (vendorId) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await fetch(
                    `${BASE_URL}/engineering/api/get/vendor-registration/${vendorId}`,
                    {
                        method: "GET",

                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            const data =
                await response.json();

            if (
                response.status === 500 &&
                data.message ===
                "vendorId not found"
            ) {

                return {
                    vendorNotFound: true,
                    error:
                        "Vendor not registered",
                };
            }

            if (!response.ok) {
                throw new Error(
                    `HTTP ${response.status}`
                );
            }

            const filteredVendor = {
                vendorId:
                    data.vendorId,

                city:
                    data.city,

                state:
                    data.state,

                pincode:
                    data.pincode,

                address:
                    data.fullAddress,

                latitude:
                    data.latitude,

                longitude:
                    data.longitude,

                approvalStatus:
                    data.approvalStatus,

                approvalRemarks:
                    data.approvalRemarks,

                bankDetails: {
                    accountNumber:
                        data.bankAccountNumber,

                    ifscCode:
                        data.ifscCode,

                    bankName:
                        data.bankName,

                    branchName:
                        data.branchName,
                },
            };

            return {
                vendorNotFound: false,
                data:
                    filteredVendor,
            };

        } catch (error) {

            console.error(
                "❌ get-vendor-details error:",
                error
            );

            throw error;
        }
    };

// ================= APPROVE ENGINEERING VENDOR =================
export const approveEngineeringVendorAPI =
    async (vendorId) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await fetch(
                    `${BASE_URL}/engineering/api/admin/vendor-registration/approval/${vendorId}`,
                    {
                        method: "PUT",

                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },

                        body:
                            JSON.stringify({
                                approvalStatus:
                                    true,

                                approvalRemarks:
                                    "Approved",
                            }),
                    }
                );

            const text =
                await response.text();

            if (!response.ok) {
                throw new Error(
                    text ||
                    "Approval failed"
                );
            }

            return text;

        } catch (error) {

            console.error(
                "❌ Approval Error:",
                error
            );

            throw error;
        }
    };

// ================= GET ALL ENGINEERING VENDORS =================
export const getAllEngineeringVendorsAPI =
    async () => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await fetch(
                    `${BASE_URL}/engineering/api/admin/vendor-registration/all`,
                    {
                        method: "GET",

                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            if (!response.ok) {
                throw new Error(
                    `HTTP ${response.status}`
                );
            }

            const data =
                await response.json();

            return Array.isArray(
                data
            )
                ? data
                : [];

        } catch (error) {

            console.error(
                "❌ Fetch engineering vendors error:",
                error
            );

            throw error;
        }
    };

// ================= UPDATE FOOD VENDOR DETAILS =================
export const updateFoodVendorDetailsAPI =
    async (
        vendorId,
        formData
    ) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                ) ||
                localStorage.getItem(
                    "token"
                );

            if (!token) {
                throw new Error(
                    "No authentication token found"
                );
            }

            const response =
                await axios.put(
                    `${BASE_URL}/food/api/vendors/edit/${vendorId}`,
                    formData,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "❌ Error updating vendor:",
                error
            );

            throw error;
        }
    };

// ================= VERIFY / REJECT FOOD VENDOR STATUS =================
export const updateFoodVendorStatusAPI =
    async (
        vendorId,
        vendorData
    ) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!token) {
                throw new Error(
                    "Authorization token missing"
                );
            }

            const formData =
                new FormData();

            formData.append(
                "vendorData",

                new Blob(
                    [
                        JSON.stringify(
                            vendorData
                        ),
                    ],
                    {
                        type:
                            "application/json",
                    }
                )
            );

            const response =
                await fetch(
                    `${BASE_URL}/food/api/vendors/edit/${vendorId}`,
                    {
                        method: "PUT",

                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },

                        body:
                            formData,
                    }
                );

            const responseText =
                await response.text();

            let responseData;

            try {

                responseData =
                    JSON.parse(
                        responseText
                    );

            } catch {

                responseData = {
                    message:
                        responseText,
                };
            }

            if (!response.ok) {

                if (
                    response.status ===
                    500 &&
                    responseData.message ===
                    "vendorId not found"
                ) {

                    throw new Error(
                        "Vendor not registered"
                    );
                }

                if (
                    response.status ===
                    404
                ) {

                    throw new Error(
                        "Vendor not registered"
                    );
                }

                throw new Error(
                    `HTTP ${response.status}: ${responseText}`
                );
            }

            return responseData;

        } catch (error) {

            console.error(
                "❌ Vendor status update error:",
                error
            );

            throw error;
        }
    };


// ================= GET ALL EMPLOYEES =================
export const getAllEmployeesAPI =
    async () => {

        try {

            const parentId =
                localStorage.getItem(
                    "userId"
                );

            const token =
                localStorage.getItem(
                    "authToken"
                );

            if (!parentId) {
                throw new Error(
                    "No parentId found"
                );
            }

            if (!token) {
                throw new Error(
                    "No authToken found"
                );
            }

            const response =
                await axios.get(
                    `${BASE_URL}/subscription/api/admins/get/all`,
                    {
                        headers: {
                            "Content-Type":
                                "application/json",

                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            // Filter by parentId
            const filtered =
                response.data.filter(
                    (emp) =>
                        emp.parentId ===
                        Number(parentId)
                );

            return filtered;

        } catch (error) {

            console.error(
                "❌ Failed to fetch employees:",
                error
            );

            throw error;
        }
    };

// ================= DELETE EMPLOYEE =================
export const deleteEmployeeAPI =
    async (id) => {

        try {

            const token =
                localStorage.getItem(
                    "authToken"
                );

            const response =
                await axios.delete(
                    `${BASE_URL}/subscription/api/admin/delete/${id}`,
                    {
                        headers: {
                            Authorization:
                                `Bearer ${token}`,
                        },
                    }
                );

            return response.data;

        } catch (error) {

            console.error(
                "❌ Delete employee failed:",
                error
            );

            throw error;
        }
    };

// ================= ADD / UPDATE EMPLOYEE =================
export const saveEmployeeAPI =
    async ({
        form,
        isEditing,
        editEmployeeId,
    }) => {

        try {

            const parentId =
                localStorage.getItem(
                    "userId"
                );

            if (!parentId) {
                throw new Error(
                    "Authentication failed. Please login again."
                );
            }

            const allowedModules = [
                "Home",
                "subscription",
                "Client_Management",
                "Order_Management",
                "user_management",
                "Account_History",
                "Menu_Management",
                "Report_Analysis",
                "Delivery_Management",
                "Care_Management",
                "Settings_Controls",
                "Promotions_Discounts",
            ];

            const cleanedModules =
                (
                    form.businessModules ||
                    []
                ).filter((m) =>
                    allowedModules.includes(
                        m
                    )
                );

            const payload = {
                id:
                    editEmployeeId ||
                    0,

                name:
                    `${form.name}`.trim(),

                email:
                    form.email,

                phoneNumber:
                    form.phoneNumber?.toString() ||
                    "",

                businessType:
                    "TECH",

                handlingRole:
                    form.handlingRole ||
                    "HEAD",

                termsAccepted:
                    true,

                parentId:
                    Number(parentId),

                enabled:
                    true,

                registerTime:
                    new Date().toISOString(),

                businessModules:
                    cleanedModules.length
                        ? cleanedModules
                        : ["Home"],

                businessVerticals:
                    form
                        .businessVerticals
                        .length
                        ? form.businessVerticals
                        : [
                            "FOOD_AND_BEVERAGES",
                        ],

                accountNonLocked:
                    true,

                credentialsNonExpired:
                    true,

                accountNonExpired:
                    true,
            };

            // UPDATE
            if (
                isEditing &&
                editEmployeeId
            ) {

                const authToken =
                    localStorage.getItem(
                        "authToken"
                    );

                const response =
                    await axios.put(
                        `${BASE_URL}/subscription/api/admin/update/${editEmployeeId}`,
                        payload,
                        {
                            headers: {
                                "Content-Type":
                                    "application/json",

                                Authorization:
                                    `Bearer ${authToken}`,
                            },
                        }
                    );

                return {
                    success: true,
                    message:
                        "Employee updated successfully!",
                    data:
                        response.data,
                };
            }

            // ADD
            const response =
                await axios.post(
                    `${BASE_URL}/subscription/api/admin/registration`,
                    payload,
                    {
                        headers: {
                            "Content-Type":
                                "application/json",

                            Accept:
                                "*/*",
                        },
                    }
                );

            return {
                success: true,
                message:
                    "Employee added successfully!",
                data:
                    response.data,
            };

        } catch (error) {

            console.error(
                "❌ Failed to save employee:",
                error
            );

            throw error;
        }
    };


